/** A game day as the calendar shows it. There's no month or year: only weeks. */
export interface CalendarDay {
  /** 0–6, Monday first. */
  readonly weekday: number
  /** From 1. */
  readonly week: number
}

/** Day 1 (a new game's first) is Monday of week 1; day 8 is Monday of week 2. */
export function calendarOf(day: number): CalendarDay {
  const index = day - 1
  return { weekday: index % 7, week: Math.floor(index / 7) + 1 }
}
